import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface UserAnalyticsData {
  pageviews: number | null;
  visitors: number | null;
  topCountry: string | null;
}

export function useUserAnalytics(username: string) {
  const [data, setData] = useState<UserAnalyticsData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!username) return;

    async function fetchAnalytics() {
      setLoading(true);
      setError(null);
      try {
        const { data: result, error: fnError } = await supabase.functions.invoke(
          "get-user-analytics",
          { body: { username } }
        );
        if (fnError) throw new Error(fnError.message);
        setData(result);
      } catch (err: any) {
        setError(err.message ?? "Erro ao buscar analytics");
      } finally {
        setLoading(false);
      }
    }

    fetchAnalytics();
  }, [username]);

  return { data, loading, error };
}
